export default __webpack_public_path__ + "static/media/typing.f9b25647.gif";